/* eslint-disable @typescript-eslint/no-empty-function */
import { TIPO_RELACION_FLUJO_TESORERIA } from "api/Types/TipoRelacionFlujoTesoreria"
import TesoreriaService from "common/services/TesoreriaService"
import {
  FechaBodyTemplate,
  ImporteBodyTemplate,
  TipoRemesaTemplate,
} from "features/Documentos/templates"
import { nanoid } from "nanoid"

export const getColumns = (
  // @ts-expect-error TS(6133): 'isInDetailView' is declared but its value is neve...
  isInDetailView: $TSMigrationFixMe,
  onRenderDownloadIcon: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  const columns = [
    {
      key: nanoid(),
      header: `${t("remesas.tab.headerDate")}`,
      sortable: true,
      filter: false,
      body: FechaBodyTemplate,
      field: "fecha",
      customFilter: {
        type: "date",
        name: "fecha",
      },
      isInDetailView: true,
    },
    {
      key: nanoid(),
      header: `${t("remesas.tab.headerType")}`,
      body: (rowData: $TSMigrationFixMe) => TipoRemesaTemplate(rowData, t),
      sortable: true,
      field: "tipo",
    },
    {
      key: nanoid(),
      header: `${t("remesas.tab.headerConcept")}`,
      sortable: true,
      filter: false,
      field: "concepto",
      customFilter: {
        type: "input",
        name: "concepto",
      },
      isInDetailView: true,
    },
    {
      key: nanoid(),
      header: `${t("remesas.tab.headerBank")}`,
      sortable: true,
      field: "iban",
    },
    {
      key: nanoid(),
      header: `${t("remesas.tab.headerMov")}`,
      sortable: true,
      filter: false,
      field: "numeroMovimientos",
      customFilter: {
        type: "input",
        name: "numeroMovimientos",
      },
    },
    {
      key: nanoid(),
      header: `${t("remesas.tab.headerTax")}`,
      sortable: true,
      body: ImporteBodyTemplate,
      field: "importe",
    },
    {
      key: nanoid(),
      body: (props: $TSMigrationFixMe) => onRenderDownloadIcon(props),
      isFunctionComponent: true,
      headerStyle: {
        width: "auto",
      },
      className: "tw-flex tw-justify-end !tw-px-6",
      isInDetailView: false,
    },
  ]
  return columns
}

export const DOWNLOAD_SUCCESS_MSG = "Remesa descargada correctamente."
export const DOWNLOAD_FAILURE_MSG =
  "Han surgido problemas descargando la remesa"

export const DOWNLOAD_REMESA_SEPA_SETUP = {
  [TIPO_RELACION_FLUJO_TESORERIA.SIN_RELACION]: {
    downloadDocument: TesoreriaService.downloadRemesaSinRelacionFile,
  },
  [TIPO_RELACION_FLUJO_TESORERIA.FACTURA]: {
    downloadDocument: TesoreriaService.donwloadRemesaFile,
  },
  [TIPO_RELACION_FLUJO_TESORERIA.PRESTAMO]: {
    downloadDocument: TesoreriaService.donwloadRemesaPrestamoFile,
  },
  [TIPO_RELACION_FLUJO_TESORERIA.DEVOLUCION]: {
    downloadDocument: TesoreriaService.donwloadRemesaDevolucionFile,
  },
  [TIPO_RELACION_FLUJO_TESORERIA.TICKET]: {
    downloadDocument: TesoreriaService.donwloadRemesaTicketFile,
  },
}
